const initFaq = () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.entry-faq').forEach((faq) => {
    const controls = new Map();

    faq.querySelectorAll('.entry-faq__item').forEach((item) => {
      const summary = item.querySelector('.entry-faq__question');

      if (!summary || item.dataset.faqInitialized) {
        return;
      }

      item.dataset.faqInitialized = 'true';
      let expanded = item.open;
      let animation;

      const setExpanded = (next) => {
        if (expanded === next) {
          return;
        }

        const startHeight = item.getBoundingClientRect().height;

        if (animation) {
          animation.cancel();
          animation = null;
        }

        expanded = next;

        if (reduceMotion.matches || !item.animate) {
          item.open = next;
          item.style.removeProperty('overflow');
          return;
        }

        item.open = true;

        const border =
          parseFloat(window.getComputedStyle(item).borderBottomWidth) || 0;
        const closedHeight = summary.getBoundingClientRect().height + border;
        const endHeight = next
          ? item.getBoundingClientRect().height
          : closedHeight;

        item.style.overflow = 'hidden';
        animation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 300, easing: 'ease-in-out' }
        );

        animation.onfinish = () => {
          item.open = expanded;
          item.style.removeProperty('overflow');
          animation = null;
        };
      };

      controls.set(item, { setExpanded, isExpanded: () => expanded });

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        const opening = !expanded;

        if (opening) {
          controls.forEach((control, other) => {
            if (other !== item && control.isExpanded()) {
              control.setExpanded(false);
            }
          });
        }

        setExpanded(opening);
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaq);
} else {
  initFaq();
}
